import React from "react";

export function Spinner({ className = "" }) {
  return (
    <div className={`flex justify-center py-12 ${className}`} data-testid="loading-spinner">
      <div className="h-8 w-8 rounded-full border-2 border-maroon border-t-transparent animate-spin" />
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", message }) {
  return (
    <div className="text-center py-14 px-6" data-testid="empty-state">
      <p className="font-serif text-xl text-ink">{title}</p>
      {message && <p className="mt-2 text-sm text-ink-muted max-w-md mx-auto">{message}</p>}
    </div>
  );
}

export function Badge({ children, tone = "gold" }) {
  const tones = {
    gold: "bg-gold-50 text-gold-dark border border-gold-light/60",
    maroon: "bg-maroon-50 text-maroon border border-maroon-100",
    green: "bg-green-50 text-green-800 border border-green-200",
    gray: "bg-gray-100 text-gray-700 border border-gray-200",
  };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold uppercase tracking-wider ${tones[tone] || tones.gold}`}
    >
      {children}
    </span>
  );
}
